import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-multientry",
  "use": "icon-multientry-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"icon-multientry\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFF\" cx=\"19\" cy=\"19\" r=\"18\" /><path d=\"M30.43 28.937h-4.458V13.424h-.056l-5.315 15.513h-3.4l-5.113-15.513h-.057v15.513H7.573V8.71h6.743l4.656 13.2h.057l4.686-13.2h6.714v20.227zM19 0C8.522 0 0 8.523 0 19c0 10.478 8.522 19 19 19 10.477 0 19-8.522 19-19C38 8.523 29.477 0 19 0z\" fill=\"#00A3D2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol